/**
 * # getRoundedNumber
 * @function getRoundedNumber
 * @description Return a rounded number from a float value.
 * @param {number} number
 * @returns {number} And integer value
 */
export default function getRoundedNumber (number) {
    let roundedNumber = 0;

    try {
        const value = Math.round(number);
        roundedNumber = value;
    } catch (error) {}

    return roundedNumber;
}
